import { Theme } from "@mui/material/styles";
import { CustomTheme } from "enums/customTheme";
import { RootState, useSelector } from "redux/store";
//
import {
  CheckboxIcon,
  CheckboxCheckedIcon,
  CheckboxIndeterminateIcon,
} from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Checkbox(theme: Theme) {
  const customTheme = useSelector(
    (state: RootState) => state.supplier.supplier?.customTheme,
  );
  const iconColor =
    customTheme === CustomTheme.Volotea
      ? theme?.palette?.volotea?.mustard
      : "#0B427A";
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: (
          <CheckboxIcon
            sx={{
              color: iconColor,
            }}
          />
        ),
        checkedIcon: (
          <CheckboxCheckedIcon
            sx={{
              color: iconColor,
            }}
          />
        ),
        indeterminateIcon: <CheckboxIndeterminateIcon />,
        // indeterminateCheckedIcon: <CheckboxCheckedIcon />,
      },

      styleOverrides: {
        root: {
          padding: theme.spacing(0.5),
          "&.Mui-checked.Mui-disabled, &.Mui-disabled": {
            color: theme.palette.action.disabled,
          },
          "& .MuiSvgIcon-fontSizeMedium": {
            width: 24,
            height: 24,
          },
          "& .MuiSvgIcon-fontSizeSmall": {
            width: 20,
            height: 20,
          },
          svg: {
            fontSize: 24,
            "&[font-size=small]": {
              fontSize: 20,
            },
          },
        },
      },
    },
  };
}